/**
 * 会员权益
 */
import $goods from '@/api/modules/goods'
import { AsyncRequest } from '@/utils/request'
import { storage } from '@/utils' 

const state = {
  selectedPlan: {},
  termApplyResult: {}
}

const getters = {
  selectedPlan: state => state.selectedPlan,
  termApplyResult: state => state.termApplyResult
}

const mutations = {
  setSelectedPlan: (state, plan) => {
    state.selectedPlan = plan
  },
  setTermApplyResult: (state, result) => {
    // 本地缓存
    const id = result.userTermId || result.termId
    storage.StudyplanApplyStatus(id).setItem(result)
    state.termApplyResult = result
  },
  getTermApplyResult: (state, { id }) => {
    // 本地缓存
    state.termApplyResult = storage.StudyplanApplyStatus(id || 0).getItem()
  }
}

const actions = {
  joinTerm({ commit }, data) {
    return AsyncRequest({
      loading: true,
      request: () => $goods.joinTerm(data),
      resolve: (result) => {
        const { joinValid } = result
        result.joinValid = false // 已报名标识
        result.do_joinValid = joinValid // 报名结果
        commit('setTermApplyResult', result)
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
